<style scoped>
.box{
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.myChart{
  width: 6rem;
  height: 6rem;
}
.title{
  font-size: .3rem;
  color: #010101;
  text-align: left;
  width: 6.9rem;
  margin-bottom: .3rem;
}
.img{
  width: 6.79rem;
  height: 2.66rem;
  background: url("~assets/lct.png") no-repeat center/cover;
}
</style>
<template>
  <div class="box">
    <div class="myChart" v-for="item in workUserList"></div>
  </div>
</template>
<script>
import {getSource, getSources} from "../api"
// import echarts from 'echarts'
import noMoreData from 'components/no-more-data'
import newsTopBox from 'components/newsTopBox'
import topbar from 'components/topbar'
import moment from 'moment/moment'
import footerBox from 'components/footer'
import {Swiper, Slide} from 'vue-swiper-component';

export default {
  data() {
    return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      workUserList:[],
    }
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
    footerBox,
    newsTopBox
  },
  filters: {
    time(value) {
      let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
      return transTime
    },
  },
  computed: {},
  methods: {
    async getScaleData() {
      let obj = {}
      obj.type = 1;
      let data = await getSources("/bear-scale/api/scaleData/getScaleData.json", obj);
      if (data.status === 0) {
        this.workUserList=data.workUserList
        let myChartAll = document.getElementsByClassName('myChart');
        setTimeout(()=>{
          this.aa()
        })
      }else{
        alert(data.msg)
      }
    },
    aa(){

      let myChartAll = document.getElementsByClassName('myChart');
      this.workUserList.forEach((v,i)=>{
        let myChart = echarts.init(myChartAll[i]);
        myChart.setOption(
          {
            title: {
              text: `${v.shortName}总人数：${v.zeroCount + v.oneCount + v.twoCount}`,
              // subtext: '300',
              left: 20,
              top:20
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              left: 20,
              bottom: 20,
              data: ['重度', '中度', '一般']
            },
            color:['#37E77D', '#AD84FF','#FFC13C'],
            series: [
              {
                name: '测评情况',
                type: 'pie',
                radius: ['50%', '70%'],
                center: ['60%', '50%'],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '14',
                  }
                },
                labelLine: {
                  show: false
                },
                data: [
                  {value: v.twoCount, name: '重度'},
                  {value: v.oneCount, name: '中度'},
                  {value: v.zeroCount, name: '一般'},
                ]
              }
            ]
          }
        )
      })

    },
    handleScroll() {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
      if (bottomOfWindow && this.isLoading == false) {

        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
          this.noMoreData = true
        } else {
          this.isLoading = true;
          this.pageIndex = this.pageIndex + 1;
          this.getDoctorList()
        }
      }
    },
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
  },
  mounted() {
    this.getScaleData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/informationDetail.vue?1e76579a